export const whatsIncludedBlocks = {
    key: "whats-included-blocks",
    init: (value) => {
        let styleEl = document.getElementById("whats-included-style");
        if(!styleEl) {
            styleEl = document.createElement("style");
            styleEl.id = "whats-included-style"
            // Append <style> element to <head>
            document.head.appendChild(styleEl);
        }
        const styleSheet = styleEl.sheet;
        if(value) {
            styleSheet.insertRule(".product-info__promo-drawer{display:none;}", styleSheet.cssRules.length);
            styleSheet.insertRule("vpv-pdp-view-links #whats-included{display:none;}", styleSheet.cssRules.length);
            styleSheet.insertRule(".product-info__whats-included{display:block;}", styleSheet.cssRules.length);
            styleSheet.insertRule(".product-info__what-youll-need{display:block;}", styleSheet.cssRules.length);
        }else{
            styleSheet.insertRule(".product-info__promo-drawer{display:block;}", styleSheet.cssRules.length);
            styleSheet.insertRule("vpv-pdp-view-links #whats-included{display:inline;}", styleSheet.cssRules.length);
            styleSheet.insertRule(".product-info__whats-included{display:none;}", styleSheet.cssRules.length);
            styleSheet.insertRule(".product-info__what-youll-need{display:none;}", styleSheet.cssRules.length);
        }
    }
}